import CustomFormat from '@/helpers/custom-format'

export default {
  filtro: {
    perfil: function(usuarioList, selecionado) {
      if (!selecionado || selecionado == '' || selecionado.id == 99) {
        return usuarioList;
      } else {
        return usuarioList.filter((usuario) => {
          return usuario.perfil.id == selecionado.id;
        });
      }
    },
    status: function(usuarioList, selecionado) {
      if (!selecionado || selecionado.ativo == null || selecionado == '') {
        return usuarioList;
      } else {
        return usuarioList.filter((usuario) => {
          return usuario.ativo == selecionado.ativo;
        });
      }
    },
    busca: function(usuarioList, pesquisa) {
      if (!pesquisa || pesquisa == '') {
        return usuarioList;
      } else {
        return usuarioList.filter((usuario) => {
          return CustomFormat.removerAcentos(usuario.nome).includes(CustomFormat.removerAcentos(pesquisa));
        });
      }
    },
    
    
    /*,
    pagina: function(usuarioList, paginacao) {
      var maxLength = (paginacao.pagina * paginacao.numElementosPagina);
      var minLength = (maxLength - paginacao.numElementosPagina);
      return usuarioList.slice(minLength, maxLength);
    },
    paginaResize: function(grupoList, paginacao, filtro) {
      if (filtro.pesquisa != '' && (filtro.status.ativo == null)) {
        paginacao.pagina = 1;
        paginacao.numPaginas = parseInt(grupoList.length/15) + 1;
      }
      return paginacao;
    }*/
  }
}


// WEBPACK FOOTER //
// ./src/components/pages/usuarios/functions.js